export * from './entities-tabs';
export * from './entities-widgets-collection';
export * from './entities-details';